import React from 'react';
import { FileText } from 'lucide-react';

interface ReportEmptyStateProps {
  message?: string;
}

const ReportEmptyState: React.FC<ReportEmptyStateProps> = ({ 
  message = 'Please apply filters to generate and view the report data.' 
}) => {
  return (
    <div className="flex flex-col justify-center items-center py-16 px-16 text-center min-h-[40vh]">
      <FileText className="h-12 w-12 text-gray-400 mb-4" />
      <p className="text-gray-500 max-w-md mb-6">
        {message}
      </p>
    </div>
  );
};

export default ReportEmptyState;
